module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8017.19fec4c9.png";